import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'odin-error-page',
  templateUrl: './error-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./error-page.component.scss'],
})
// A 404 is a routing miss, not a failed request: it has no trace of its own, and the last
// reference shown elsewhere in the session would point support at an unrelated error.
export class ErrorPageComponent {}
